module.exports = __webpack_public_path__ + "img/y_p3_x5.25ec884e.svg";